<div>
    <div class="view-wrapper">
        <div class="left-side-header">
            <div class="view-mode" #viewModeContainer>
                <div
                    class="mode left"
                    data-cy="channels-simple-view-button"
                    [class.active]="viewMode === SIMPLE_VIEW"
                    (click)="selectViewMode(SIMPLE_VIEW)">
                    {{ 'channel.label.simpleView' | translate }}
                </div>
                <div
                    class="mode right"
                    data-cy="channels-view-all-button"
                    [class.active]="viewMode === VIEW_ALL"
                    (click)="selectViewMode(VIEW_ALL)">
                    {{ 'channel.label.viewAll' | translate }}
                    <span *ngIf="hiddenErrors > 0" class="view-all-error-badge"></span>
                </div>
            </div>
            <div class="help-wrapper" #helperContainer>
                <mat-icon
                    svgIcon="help"
                    style="cursor: pointer"
                    data-cy="channels-view-tooltip"
                    (click)="$event.stopPropagation(); toggleDropdowns(INFO_MESSAGE)"></mat-icon>
                <ng-container *ngIf="this.currentPanel == INFO_MESSAGE">
                    <div #infoMessage class="info-message-container" data-cy="channels-tooltip-text">
                        <div>
                            {{ 'channel.page.info-message.part1' | translate }}
                        </div>
                        <br />
                        <div>
                            {{ 'channel.page.info-message.part2' | translate }}
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="alarm-wrapper" *ngIf="alarmColumns" #alarmLevelsContainer>
                <div
                    class="alarm"
                    data-cy="channels-alarm-levels-show-hide-icon"
                    (click)="$event.stopPropagation(); toggleDropdowns(ALARM_MESSAGE)">
                    {{ 'channel.dropdown-alarm.title' | translate }}
                    <mat-icon
                        class="arrow"
                        [class.focus]="this.currentPanel == ALARM_MESSAGE"
                        svgIcon="dropdown-arrow" />
                </div>
                <div class="dialog-container" #alarmDialog [class.show]="this.currentPanel == ALARM_MESSAGE">
                    <div
                        *ngFor="let alarmColumn of alarmColumns"
                        class="alarm"
                        data-cy="channels-alarm-levels-show-hide-option"
                        (click)="selectedShowAlarm(alarmColumn, $event)">
                        {{ 'channel.label.alarm.' + alarmColumn | translate }}
                        <mat-icon
                            svgIcon="visible"
                            data-cy="channels-alarm-levels-show-hide-option-icon-open"
                            *ngIf="selectedAlarmKeys.has(alarmColumn)"></mat-icon>
                        <mat-icon
                            svgIcon="invisible"
                            data-cy="channels-alarm-levels-show-hide-option-icon-closed"
                            *ngIf="!selectedAlarmKeys.has(alarmColumn)"></mat-icon>
                    </div>
                </div>
                <div class="validation-checkbox">
                    <mat-checkbox
                        [(ngModel)]="isValidationEnabled"
                        (mousedown)="$event.preventDefault()"
                        (change)="validationButtonClicked()">
                    </mat-checkbox>
                    <div class="checkbox-label" (click)="toggleValidationCheckbox()">
                        {{ 'channel.header.enable-validation-check.checkbox' | translate }}
                    </div>
                </div>
            </div>
        </div>

        <div class="file-button-wrapper">
            <input type="file" class="excelFile" (change)="completeFileSelected($event)" #excelFileInput />
            <input type="file" class="excelFile" (change)="simpleFileSelected($event)" #simpleFileInput />
            <div
                class="button-wrapper row-buttons"
                data-cy="channels-print-button"
                [class.disabled]="sheetIsEmpty()"
                (click)="printChannels()">
                {{ 'channel.print' | translate }}
            </div>
            <div
                class="button-wrapper row-buttons"
                [class.disabled]="isSystemChannelsGroup() || sheetIsEmpty() || !userCanEdit"
                data-cy="channels-insert-rows-below-button"
                (click)="insertRows(false)">
                {{ 'dlg.channel-sheet.insert-rows.title-below' | translate }}
            </div>
            <div
                class="button-wrapper row-buttons"
                [class.disabled]="isSystemChannelsGroup() || sheetIsEmpty() || !userCanEdit"
                data-cy="channels-insert-rows-above-button"
                (click)="insertRows(true)">
                {{ 'dlg.channel-sheet.insert-rows.title-above' | translate }}
            </div>
            <div
                class="import button-wrapper"
                data-cy="channels-import-button"
                (click)="importButtonClick()"
                [class.disabled]="isImportButtonDisabled()">
                <mat-icon svgIcon="import"></mat-icon>
                <span>{{ 'channel.import' | translate }}</span>
            </div>
            <div
                class="export button-wrapper"
                data-cy="channels-download-button"
                [class.disabled]="sheetIsEmpty()"
                (click)="downloadButtonClick()">
                <mat-icon svgIcon="export"></mat-icon>
                <span>{{ 'channel.export' | translate }}</span>
            </div>
        </div>
    </div>
</div>

<div class="channel-group-tabs-container" #channelSheetMenu>
    <div class="channel-group-tabs" data-cy="channels-channel-group-tab-list" #tabScrollContainer>
        <div
            *ngFor="let group of channelGroupList; let index = index"
            #tabEl
            (click)="selectGroup(group, tabEl)"
            class="channel-group-tab"
            data-cy="channels-channel-group-tab"
            [class.active]="activeGroup?.id === group.id">
            {{ group.rowNum }}
        </div>
        <button
            class="channel-group-add"
            data-cy="channels-new-channel-group-button"
            (click)="openGroupDialog()"
            [disabled]="!userCanEdit"
            #addChannelGroupButton>
            <mat-icon class="add-icon" svgIcon="add-box"></mat-icon>
            {{ 'channel.add-group' | translate }}
        </button>
    </div>
</div>

<div *ngIf="textColorIsOpen">
    <app-excel-color-picker
        style="width: 100%; height: 100%; position: relative; top: 90px; left: 430px"
        [selectedColor]="textColor"
        (onColorSelected)="updateTextColor($event)"
        (onClosePicker)="textColorIsOpen = false">
    </app-excel-color-picker>
</div>

<div *ngIf="fillColorIsOpen">
    <app-excel-color-picker
        style="width: 100%; height: 100%; position: relative; top: 90px; left: 475px"
        [selectedColor]="fillColor"
        (onColorSelected)="updateCellColor($event)"
        (onClosePicker)="fillColorIsOpen = false">
    </app-excel-color-picker>
</div>

<div #spreadsheet [hidden]="channelGroupList.length === 0"></div>

<ng-container *ngIf="hasCellError && isValidationEnabled">
    <div
        #errorsContainer
        class="error-icon-wrapper"
        [ngStyle]="{
            right: errorIconRight ? errorIconRight : 'unset',
            left: errorIconLeft ? errorIconLeft : 'unset',
        }"
        (click)="$event.stopPropagation(); toggleDropdowns(ERROR_MESSAGE)">
        <mat-icon svgIcon="save-error" class="error-icon" />
        <div class="errors-list" *ngIf="currentPanel == ERROR_MESSAGE">
            <div
                *ngFor="let error of visibleCellErrors"
                class="error-message"
                (click)="focus(error.position.x, error.position.y)">
                <div [innerHTML]="generateMessage(error)"></div>
            </div>
            <div class="error-message" *ngIf="hiddenErrors > 0">
                <div [innerHTML]="'channel.validation.errors.hidden' | translate: { count: hiddenErrors }"></div>
            </div>
        </div>
    </div>
</ng-container>

<app-confirmation-window
    #importErrorDialog
    [mainLabel]="'excel-channel-import.errors.title'"
    [subLabel]="importErrorMessage"
    [saveLabel]="'dlg.notification.close-button'"
    [errorIcon]="true"></app-confirmation-window>
